import 'react-native-get-random-values';

import {Alert, Platform, SafeAreaView, useWindowDimensions} from 'react-native';
import React from 'react';

//splash screen contols import for app loading
import * as SplashScreen from 'expo-splash-screen';

//redux actions
import {useDispatch} from 'react-redux';

import {useFocusEffect} from '@react-navigation/native';

import {setHostMaximized} from '../Redux/reducers/event.reducer';
import {messaging} from '../Utils/db';

import LottieView from 'lottie-react-native';

import {
  setHasSeenTurtorial,
  setPreviousVisit,
} from '../Redux/reducers/current_screen.reducer';

import {
  setDeviceUUID,
  setVersionInfo,
} from '../Redux/reducers/app_info.reducer';
import {mmkvStorage} from '../Utils/mmkvStorage';

var LaunchArguments;

if (Platform.OS !== 'web') {
  const ReactNativeLaunchArguments = require('react-native-launch-arguments');
  LaunchArguments = ReactNativeLaunchArguments?.ReactNativeLaunchArguments;
} else {
  LaunchArguments = {
    value: () => {},
  };
}
import {logOutUser} from '../Redux/reducers/user_info.reducer';
import {navigationRef} from '../Nav/navigationHelpers';

const {v4: uuidv4} = require('uuid');

const AppLoadingPage = () => {
  const dispatch = useDispatch();

  const {width} = useWindowDimensions();

  useFocusEffect(() => {
    SplashScreen.hideAsync();
    async function loadApp() {
      try {
        dispatch(setHostMaximized(0));
        const launchArgs = LaunchArguments?.value?.() || {};

        console.log('AppLoadingPage: Started!', {launchArgs});
        if (launchArgs?.deleteStorage) {
          dispatch(logOutUser());
          mmkvStorage.clearAll();
          dispatch({type: 'HARD_RESET'});
        }

        //cycling through async storage to do conditional logic and redux stating based on saved data
        // let deviceUUID, previousVisit, initialVersionInfo, hasViewedTutorial;

        let deviceUUID = mmkvStorage.getString('deviceUUID');
        let previousVisit = !!mmkvStorage.getString('previousVisit')
          ? true
          : false;
        const initialVersionInfo = mmkvStorage.getString('versionInfo');
        const hasViewedTutorial = !!mmkvStorage.getString('hasViewedTutorial')
          ? true
          : false;

        console.log({
          deviceUUID,
          previousVisit,
          initialVersionInfo,
        });

        if (!deviceUUID) {
          try {
            deviceUUID = uuidv4();
            if (deviceUUID) {
              messaging().subscribeToTopic(deviceUUID);
            }
          } catch (error) {
            console.warn(
              'We could not subscribe to the device UUID topic: ',
              error,
            );
          }
          mmkvStorage.set('deviceUUID', deviceUUID);
        }

        dispatch(setDeviceUUID(deviceUUID));

        if (initialVersionInfo) {
          try {
            const parsedVersionInfo = JSON.parse(initialVersionInfo);
            dispatch(setVersionInfo(parsedVersionInfo));
          } catch (e) {
            console.log('could not parse version info');
          }
        }

        if (hasViewedTutorial) {
          console.log('setHasSeenTurtorial3');
          dispatch(setHasSeenTurtorial(1));
        } else {
          console.log('has not seen turtorial');
        }

        console.log({previousVisit});

        dispatch(setPreviousVisit(1));

        console.log('AppLoadingPage: Done!');
        if (
          previousVisit == true ||
          window?.location?.href?.includes('isDemo')
        ) {
          setTimeout(() => {
            navigationRef.navigate('LandingPageMain', null, 'App Loading Page');
          }, 2000);
        } else {
          setTimeout(() => {
            navigationRef.navigate('AppIntroSwiper', 'App Loading Page');
          }, 2000);
        }
      } catch (error) {
        if (__DEV__) {
          Alert.alert(
            'Dev alert: the app loading page had an error and defaulted to intro swiper',
          );
          console.log({error});
        }
        SplashScreen?.hideAsync?.();
        navigationRef.navigate('AppIntroSwiper');
      }
    }

    loadApp();
  });

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: global.color.orange,
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <LottieView
        source={require('src/Lottie/logo_explode.json')}
        autoPlay
        loop={false}
        style={{width}}
        speed={1}
      />
    </SafeAreaView>
  );
};

// eslint-disable-next-line
export default AppLoadingPage;
